<template>
  <div class="leco-content">
    <div v-show="mainLoading" class="loader">loading...</div>
    <transition>
      <div v-show="!mainLoading">
        <div class="page-title">調べたい人の名前を検索してください。</div>
        <div class="content-wrapper">
          <div class="sample-page">
            <link
              rel="stylesheet"
              href="https://use.fontawesome.com/releases/v5.6.3/css/all.css"
              integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/"
              crossorigin="anonymous"
            />

            <div class="mt-2 mb-2 search-area">
              <div class="hanrei-area float-left">
                <div class="float-left">
                  <span class="hanrei-label">凡例</span>
                </div>
                <div class="float-left">
                  <div>
                    【TS】：トレーニングスタンプラリー対象 【PL】：Project
                    Leaderトレーニングシリーズ
                  </div>
                  <div>
                    絶対参加：なんとしても受講したい、受講希望：都合が合えば受講したい
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div class="user-select float-right">
                <v-select
                  :options="users"
                  label="name"
                  id="user-list"
                  v-model="selectedUserId"
                  :reduce="(users) => users.id"
                  @input="changeUser"
                >
                </v-select>
                <div v-show="miniLoading" class="mini-loader float-left"></div>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div v-if="selected_user_full_name != ''" class="page-title">
            {{ selected_user_full_name }}のトレーニング状況
          </div>
          <vue-good-table
            :columns="columns"
            :rows="rows"
            max-height="82vh"
            :fixed-header="true"
            :search-options="{
              enabled: true
            }"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'training_name'">
                <router-link
                  :to="{
                    name: 'wish-list-detail',
                    params: { id: props.row.all_training_id }
                  }"
                  >{{ props.row.training_name }}</router-link
                >
              </span>

              <span v-else-if="props.column.field == 'attended_flag_name'">
                <select
                  :value="
                    props.row.all_training_id + '-' + props.row.attended_flag
                  "
                  @input="attendedChange"
                >
                  <option
                    :value="props.row.all_training_id + '-0'"
                    selected
                  ></option>
                  <option :value="props.row.all_training_id + '-1'" selected>
                    未受講
                  </option>
                  <option :value="props.row.all_training_id + '-2'">
                    受講済
                  </option>
                </select>
              </span>

              <span v-else-if="props.column.field == 'want_status_name'">
                <select
                  :value="
                    props.row.all_training_id + '-' + props.row.want_status
                  "
                  @input="wantStatusChange"
                >
                  <option
                    :value="props.row.all_training_id + '-0'"
                    selected
                  ></option>
                  <option :value="props.row.all_training_id + '-1'" selected>
                    受講しない
                  </option>
                  <option :value="props.row.all_training_id + '-2'">
                    受講希望
                  </option>
                  <option :value="props.row.all_training_id + '-3'">
                    絶対参加
                  </option>
                </select>
              </span>

              <span v-else-if="props.column.field == 'coach_status_name'">
                <select
                  :value="
                    props.row.all_training_id + '-' + props.row.coach_status
                  "
                  @input="coachStatusChange"
                >
                  <option
                    :value="props.row.all_training_id + '-0'"
                    selected
                  ></option>
                  <option :value="props.row.all_training_id + '-1'" selected>
                    講師不可
                  </option>
                  <option :value="props.row.all_training_id + '-2'">
                    講師可能
                  </option>
                </select>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import jQuery from "jquery";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Vue from "vue";
import { API_BASE_URL } from "@/common/config";
Vue.use(VueGoodTablePlugin);
// vue-select
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "star-list",

  data() {
    return {
      columns: [
        {
          label: "メインカテゴリー",
          field: "training_category_name",
          thClass: "mobileDisplayNone mobileStyle",
          tdClass: "mobileDisplayNone mobileStyle"
        },
        {
          label: "サブカテゴリー",
          field: "training_sub_category_name",
          thClass: "mobileDisplayNone mobileStyle",
          tdClass: "mobileDisplayNone mobileStyle"
        },
        {
          label: "トレーニング名",
          field: "training_name",
          thClass: "mobileStyle trainingColumn",
          tdClass: "mobileStyle trainingColumn"
        },
        {
          label: "実績",
          field: "attended_flag_name",
          thClass: "mobileStyle",
          tdClass: "mobileStyle"
        },
        {
          label: "希望",
          field: "want_status_name",
          thClass: "mobileStyle",
          tdClass: "mobileStyle"
        },
        {
          label: "講師可否",
          field: "coach_status_name",
          thClass: "mobileStyle",
          tdClass: "mobileStyle"
        }
      ],
      rows: [],
      user_full_name: "",
      selected_user_full_name: "",
      selectedUserId: "",
      users: [],
      error: "",
      searchError: "",
      isUserSelected: false,
      mainLoading: true,
      miniLoading: true,
      logger: this.$store.state.logger
    };
  },
  components: {
    vSelect
  },
  computed: {
    filteredUsers: function () {
      var users = [];

      for (var i in this.users) {
        var user = this.users[i];

        if (
          user.name.indexOf(this.keyword) !== -1 ||
          user.user_full_name.indexOf(this.keyword) !== -1
        ) {
          users.push(user);
        }
      }

      return users;
    },
    ...mapGetters(["isAuthenticated", "currentUser"])
  },

  methods: {
    changeUser: function () {
      this.logger.info("user_id:" + this.selectedUserId);
      this.selected_user_full_name = this.user_full_name;
      if (this.selectedUserId == null) {
        this.rows = [];
        this.logger.info("ユーザーが空欄のためテーブルデータをクリアします。");
        return;
      }
      this.getStarTrans();
    },
    getStarTrans: function () {
      this.miniLoading = true;
      this.rows = [];
      axios
        .get(API_BASE_URL + "user-star-trans?user-id=" + this.selectedUserId, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((response) => {
          this.logger.debug("response:\n" + JSON.stringify(response));
          this.logger.info("星取表データ取得成功");
          this.logger.debug(JSON.stringify(response.data.body));
          this.rows = response.data.body;
          this.miniLoading = false;
          this.mainLoading = false;
        })
        .catch((error) => {
          this.logger.error("星取表データ取得失敗: " + JSON.stringify(error));
          this.searchError = "星取表データ取得失敗";
          this.miniLoading = false;
          this.mainLoading = false;
        });
    },

    attendedChange: function (event) {
      var selectedDates = event.target.value.split("-");
      var trainingId = selectedDates[0];
      var selectedValue = selectedDates[1];
      var postData = {
        type: "attended_flag",
        value: selectedValue,
        userId: this.selectedUserId
      };
      this.logger.debug("SelectedTraining is " + trainingId);
      this.logger.debug("SelectedData is " + selectedValue);
      this.logger.info("出席情報登録：training_plan_id=" + trainingId);
      axios
        .put(API_BASE_URL + "user-star-trans/" + trainingId, postData, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((response) => {
          this.logger.info(
            "出席情報登録成功。StatusCode=" + response.data.statusCode
          );
          this.logger.debug("get result：" + JSON.stringify(response));
          this.training = response.data.body;
        })
        .catch((err) => {
          this.logger.error("出席情報登録失敗。");
          this.logger.error(JSON.stringify(err));
        });
    },

    wantStatusChange: function (event) {
      var selectedDates = event.target.value.split("-");
      var trainingId = selectedDates[0];
      var selectedValue = selectedDates[1];
      var postData = {
        type: "want_status",
        value: selectedValue,
        userId: this.selectedUserId
      };
      this.logger.debug("SelectedTraining is " + trainingId);
      this.logger.debug("SelectedData is " + selectedValue);
      this.logger.info("希望情報登録：training_plan_id=" + trainingId);
      axios
        .put(API_BASE_URL + "user-star-trans/" + trainingId, postData, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((response) => {
          this.logger.info(
            "希望情報送信成功。StatusCode=" + response.data.statusCode
          );
          this.logger.debug("get result：" + JSON.stringify(response));
          this.training = response.data.body;
        })
        .catch((err) => {
          this.logger.error("希望情報送信失敗。");
          this.logger.error(JSON.stringify(err));
        });
    },

    coachStatusChange: function (event) {
      var selectedDates = event.target.value.split("-");
      var trainingId = selectedDates[0];
      var selectedValue = selectedDates[1];
      var postData = {
        type: "coach_status",
        value: selectedValue,
        userId: this.selectedUserId
      };
      this.logger.debug("SelectedTraining is " + trainingId);
      this.logger.debug("SelectedData is " + selectedValue);
      this.logger.info("講師情報登録：training_plan_id=" + trainingId);
      axios
        .put(API_BASE_URL + "user-star-trans/" + trainingId, postData, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        })
        .then((response) => {
          this.logger.info(
            "講師情報送信成功。StatusCode=" + response.data.statusCode
          );
          this.logger.debug("get result：" + JSON.stringify(response));
          this.training = response.data.body;
        })
        .catch((err) => {
          this.logger.error("講師情報送信失敗。");
          this.logger.error(JSON.stringify(err));
        });
    }
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    //社員名一覧を取得
    let api_url = API_BASE_URL + "users";
    this.logger.info("Start to get user names");
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((response) => {
        this.logger.debug("response:\n" + JSON.stringify(response));
        if (response.data.statusCode == 200) {
          this.users = response.data.body;
          this.logger.info("End to get user names");
          this.selectedEmail =
            this.$store.getters.currentUser.idToken.payload.email;

          // ログインユーザーのmailをuserIdに変換する
          for (var user of this.users) {
            if (user.email == this.selectedEmail) {
              this.selectedUserId = user.id;
              this.logger.info("login-user-id: " + this.selectedUserId);
            }
          }

          this.changeUser();
          // ここではローディング解除しない
          // changeUser()の中で解除している
          // this.mainLoading = false;
        } else {
          this.$router.push("/system-error500");
        }
      })
      .catch((err) => {
        this.logger.error("error in getting training name");
        this.logger.error("err:\n" + JSON.stringify(err));
        this.$router.push("/system-error500");
      });
  }
};
</script>

<style scoped>
/* 検索ボックスと凡例を下寄せにするための設定 */
.search-area {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap-reverse;
}

.user-select {
  margin-left: auto;
}
#user-list {
  font-size: 120%;
  width: 300px;
}

.trainingColumn {
  max-width: 300px !important;
  word-break: break-all;
}

@media screen and (max-width: 600px) {
  #user-list {
    font-size: 100%;
    width: 100%;
  }

  .mobileDisplayNone {
    display: none;
  }

  .trainingColumn {
    max-width: 100px !important;
    word-break: break-all;
  }

  .content-wrapper {
    margin-right: 10px;
    margin-left: 10px;
  }
}

@media screen and (max-width: 1000px) {
  .mobileStyle {
    font-size: 60%;
    padding: 4px !important;
    word-break: break-all;
  }
}

/*********************************************************************************** */
/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/*********************************************************************************** */
/* mini-loadingアイコン用CSS */
.mini-loader {
  font-size: 10px;
  margin: 10px 10px;
  text-indent: -9999em;
  width: 2em;
  height: 2em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.mini-loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.mini-loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.vgt-table > tbody > tr > td > span > a {
  color: var(--leco-link-color);
}
</style>
